import $ from 'jquery';

$.fn.resizeTo = function (source) {
  return this.css('display', 'block')
    .width($(source).width())
    .height($(source).height());
};

$.fn.swapWith = function (to) {
  if ($(to).length > 0) {
    this.first().each(function () {
      var copy_to = $(to).clone(true);
      var copy_from = $(this).clone(true);

      var dummy_to = copy_to.clone().empty().resizeTo(to);
      var dummy_from = copy_from.clone().empty().resizeTo(this);

      $(to).replaceWith(dummy_to);
      $(this).replaceWith(dummy_from);

      // TODO: animate dimensions
      dummy_to.animate({
        width: dummy_from.width(),
        height: dummy_from.height(),
      });

      dummy_from.animate({
        width: dummy_to.width(),
        height: dummy_to.height(),
      });

      $(to).replaceWith(copy_from);
      $(this).replaceWith(copy_to);
    });
  }

  return this.first();
};

$.fn.saveInputValues = function () {
  this.find(':input').each(function () {
    const $this = $(this);
    $this.data('storedvalue', $this.val());
  });
  return this;
};

$.fn.restoreInputValues = function () {
  this.find(':input').each(function () {
    const $this = $(this);
    $this.val($this.data('storedvalue'));
  });
  return this;
};

$.fn.swapWith = function (to) {
  if ($(to).length > 0) {
    this.first().each(function () {
      var copy_to = $(to).saveInputValues().clone(true);
      var copy_from = $(this).saveInputValues().clone(true);
      $(to).replaceWith(copy_from);
      $(this).replaceWith(copy_to);
      copy_to.restoreInputValues();
      copy_from.restoreInputValues();
    });
  }

  return this.first();
};
